import * as z from "zod/v4";

export const hasCarrierServices = {
  name: "hasCarrierServices" as const,
  input: z.null(),
  output: z.boolean(),
};
